import React, {Component} from "react";
import {Checkbox, Button, message} from 'antd';
import {ExclamationCircleOutlined} from '@ant-design/icons';
import './printPro.sass';
import api from "../../utils/api";

export default class PrintPro extends Component {
    constructor (props) {
        super(props)
        this.state = {
            isRefund: props.isRefund,//导出售后
            exportArr: {
                arr: Array.isArray(props.exportParam) ? props.exportParam : []
            },
            exportRules: {...props.exportRules},
            printData: {...props.printData},
            result_export_rules: [],

            goods_fields: !props.isRefund ? [{name: 'goods_name', val: '商品名称'}, {name: 'goods_code', val: '商品ID/编码'},
                {name: 'spec_value', val: '规格'}, {name: 'quantity', val: '数量'}, {
                    name: 'item_total_amount',
                    val: '商品金额'
                }, {name: 'entity_price', val: '商品成本价'}] : [],

            checked_goods_fields: [],

            mailing_fields: !props.isRefund ? [{name: 'consignee_name', val: '自提点名称'}, {
                name: 'consignee_phone',
                val: '自提点电话'
            }, {name: 'address', val: '地址'}] : [],

            checked_mailing_fields: [],

            order_fields: !props.isRefund ? [{name: 'alpha_batch_no', val: '跟团号'}, {name: 'order_id', val: '订单号'},
                {name: 'user_name', val: '用户昵称'}, {name: 'payment_time', val: '支付时间'}, {
                    name: 'payment_type',
                    val: '支付方式(线下/微信)'
                },
                {name: 'delivery_type', val: '物流信息/配送类型'}, {name: 'alpha_name', val: '团长昵称'}, {
                    name: 'alpha_phone',
                    val: '团长联系方式'
                },
                {name: 'order_status', val: '订单状态'}, {name: 'remark', val: '备注信息'}, {
                    name: 'total_amount',
                    val: '订单/退款金额'
                },
                {name: 'refunded_at', val: '退款时间'}, {name: 'refunded_amount', val: '退款金额'}, {
                    name: 'user_name',
                    val: '用户昵称'
                },
                {name: 'user_mobile', val: '用户电话'}, {name: 'refunded_status', val: '售后状态'}
            ] : [{name: 'after_service_id', val: '售后编号'},
                {name: 'created_at', val: '发起时间'},
                {name: 'goods_name', val: '商品名称'},
                {name: 'refund_total_amount', val: '售后金额'},
                {name: 'refunded_status', val: '售后状态'},
                {name: 'reason', val: '售后理由'},
                {name: 'alpha_batch_no', val: '关联团购编号'},
                {name: 'order_id', val: '关联订单号'},
                {name: 'order_type', val: '订单类型'},
            ],
            checked_order_fields: [],

            group_fields: !props.isRefund ? [
                {name: 'group_name', val: '团购名称'}, {name: 'channel_name', val: '所属渠道'}, {
                    name: 'commission_rate',
                    val: '圈子服务费'
                },
                {name: 'arrival_date', val: '到货时间'}, {name: 'end_datetime', val: '截单时间'}
            ] : [],

            checked_group_fields: [],
            export_type_s: props.exportRules.export_type_s
        }
    }

    componentDidMount () {
        this.defaultChecked()//默认选中
    }

    closeHandle = () => {
        this.props.colsePop()
    }

    bornTable = async () => {//生成报表
        let {export_type_s} = this.props.exportRules;

        let {isRefund} = this.state;

        let {exportRules, exportArr, printData} = await this.state;
        if (exportArr.arr && exportArr.arr.length) {
            let arr = exportArr.arr;
            let orderIdArr = [];
            arr.map(v => {
                orderIdArr.push(v.id)
            })
            orderIdArr = orderIdArr.join(',');
            exportRules['search'] = `order_id::${orderIdArr}`;
            exportRules['searchFields'] = 'order_id::in';

            exportRules['condition'] = [
                {search: `order_id::${orderIdArr}`},
                {searchFields: 'order_id::in'}
            ]
        }

        if (export_type_s) {
            delete exportRules['order_fields']
            delete exportRules['mailing_fields']
            delete exportRules['group_fields']
            delete exportRules['goods_fields']

            exportRules['type'] = 'delivery'
        }

        if (isRefund) {
            exportRules['type'] = 'REFUND'
        }

        let res = await api('add-orders-export', exportRules);

        if (res.code === 200) {
            let hide = message.loading('订单报表生成中', 1)

            setTimeout(() => {
                this.props.jumpUrl({pathname: `/order/ordersReport`})
            }, 1000)
        } else {
            message.error(res.message)
        }
    }

    grand = (arr, type) => {//循环加参
        let {exportRules} = this.state;
        exportRules[type] = {};
        for (let i in arr) {
            arr[i] = JSON.parse(arr[i])
            exportRules[type] = {
                ...exportRules[type],
                [arr[i]['name']]: arr[i]['val']
            }
        }
        this.setState({
            exportRules
        })
    }


    defaultChecked = () => {//默认选中

        let {goods_fields, mailing_fields, order_fields, group_fields} = this.state;
        //默认选中导出整合
        let result_export_rules = {}
        //商品信息：
        for (let i in goods_fields) {
            this.state.checked_goods_fields.push(
                JSON.stringify(goods_fields[i])
            )
            result_export_rules['goods_fields'] = {
                ...result_export_rules['goods_fields'],
                [goods_fields[i]['name']]: goods_fields[i]['val']
            }
        }
        //收货信息：
        for (let i in mailing_fields) {
            this.state.checked_mailing_fields.push(
                JSON.stringify(mailing_fields[i])
            )
            result_export_rules['mailing_fields'] = {
                ...result_export_rules['mailing_fields'],
                [mailing_fields[i]['name']]: mailing_fields[i]['val']
            }
        }

        //订单信息：
        for (let i in order_fields) {
            this.state.checked_order_fields.push(
                JSON.stringify(order_fields[i])
            )
            result_export_rules['order_fields'] = {
                ...result_export_rules['order_fields'],
                [order_fields[i]['name']]: order_fields[i]['val']
            }
        }

        //团购信息：
        for (let i in group_fields) {
            this.state.checked_group_fields.push(
                JSON.stringify(group_fields[i])
            )
            result_export_rules['group_fields'] = {
                ...result_export_rules['group_fields'],
                [group_fields[i]['name']]: group_fields[i]['val']
            }
        }
        this.setState({
            exportRules: {...result_export_rules, ...this.state.exportRules}
        })
    }


    render () {
        let {
            printData,
            checked_goods_fields, checked_mailing_fields,
            checked_order_fields, checked_group_fields, export_type_s, isRefund
        } = this.state;
        const Width100 = {
            width: "100%",
        };
        const ResetExportStyle = {position: 'absolute', left: 0, right: 0, top: 0, bottom: 0}
        const TipStyle = {fontSize: 16, color: '#EB7B1B', marginRight: 5, cursor: 'pointer'};
        return (
            <div className='printPro'>
                <div style={ResetExportStyle} onClick={() => {
                    this.props.showSet(false)
                }}></div>
                <div className='printCotent'>
                    {
                        !isRefund ? (
                            <div className='title'>{printData.exportType === 'orders' ? '导出订单设置' : '导出配送单设置'}</div>

                        ) : (
                            <div className='title'>批量导出售后</div>

                        )
                    }
                    <div className='printCtx'>
                        <div className='case'>
                            <ExclamationCircleOutlined
                                style={TipStyle}/>
                            每次最多可导出5000笔，两次导出的时间间隔为30秒
                        </div>
                        {
                            !isRefund ? (
                                <div className='info'>
                                    <div className='flex team_name'>
                                        <p>团购名称：</p>
                                        {this.props.searchCondition.contractName || '所有团购'}
                                    </div>

                                    <p>到货日期：{this.props.searchCondition.arrivalDate[0] ? (this.props.searchCondition.arrivalDate[0].format('YYYY-MM-DD') +
                                        '--' + this.props.searchCondition.arrivalDate[1].format('YYYY-MM-DD')) : '不限'}</p>

                                    <p>截单日期：{this.props.searchCondition.endTime[0] ? (this.props.searchCondition.endTime[0].format('YYYY-MM-DD') +
                                        '--' + this.props.searchCondition.endTime[1].format('YYYY-MM-DD')) : '不限'}</p>

                                    <div className='detail'>
                                        <p>团长/用户：{this.props.searchCondition.mchOrUserName || '所有团长/用户'}</p>
                                        <p>订单状态：{this.props.searchCondition.orderStatusDesc}</p>
                                    </div>
                                </div>
                            ) : null
                        }


                        {
                            !export_type_s ? (
                                <div className='checkBox'>
                                    <Checkbox.Group
                                        defaultValue={checked_group_fields}
                                        style={Width100}

                                        onChange={(arr) => {
                                            this.grand(arr, 'group_fields')
                                        }}>
                                        <div className='flex select'>
                                            {
                                                !isRefund ? (
                                                    <p className='selectTitle'>团购信息：</p>

                                                ) : null
                                            }
                                            <ul>

                                                {
                                                    checked_group_fields.map((item) => {
                                                        return (
                                                            <li><Checkbox value={item}>{JSON.parse(item).val}</Checkbox>
                                                            </li>
                                                        )
                                                    })
                                                }

                                            </ul>
                                            {/* <Checkbox.Group options={options} defaultValue={['Pear']} onChange={e => onChange(e)} /> */}
                                        </div>
                                    </Checkbox.Group>


                                    <Checkbox.Group
                                        // defaultValue={printData.exportType === 'orders' ? checked_order_fields : []}
                                        defaultValue={checked_order_fields}
                                        style={Width100}

                                        onChange={(arr) => {
                                            this.grand(arr, 'order_fields')
                                        }}>

                                        <div className='flex select'>
                                            {
                                                !isRefund ? (
                                                    <p className='selectTitle'>订单信息：</p>

                                                ) : (
                                                    <p className='selectTitle'>订单信息：</p>

                                                )
                                            }
                                            <ul>
                                                {
                                                    checked_order_fields.map((item, i) => {
                                                        return (
                                                            <li key={i}><Checkbox
                                                                value={item}>{JSON.parse(item).val}</Checkbox>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>

                                    </Checkbox.Group>


                                    <Checkbox.Group
                                        defaultValue={checked_goods_fields}
                                        style={Width100}
                                        onChange={(arr) => {
                                            this.grand(arr, 'goods_fields')
                                        }}>

                                        <div className='flex select'>
                                            {
                                                !isRefund ? (
                                                    <p className='selectTitle'>商品信息：</p>

                                                ) : null
                                            }
                                            <ul>
                                                {
                                                    checked_goods_fields.map((item, i) => {
                                                        return (
                                                            <li key={i}><Checkbox
                                                                value={item}>{JSON.parse(item).val}</Checkbox>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>

                                    </Checkbox.Group>


                                    <Checkbox.Group
                                        defaultValue={checked_mailing_fields}
                                        style={Width100}

                                        onChange={(arr) => {
                                            this.grand(arr, 'mailing_fields')
                                        }}>

                                        <div className='flex select'>
                                            {
                                                !isRefund ? (
                                                    <p className='selectTitle'>收货信息：</p>

                                                ) : null
                                            }
                                            <ul>
                                                {
                                                    checked_mailing_fields.map((item, i) => {
                                                        return (
                                                            <li key={i}><Checkbox
                                                                value={item}>{JSON.parse(item).val}</Checkbox>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </Checkbox.Group>
                                </div>
                            ) : null
                        }
                    </div>
                    <div className='contrlBtn flex'>
                        <Button onClick={() => {
                            this.closeHandle()
                        }}>关闭</Button>
                        <Button onClick={() => {
                            this.bornTable()
                        }}>生成报表</Button>
                    </div>
                </div>
            </div>
        )
    }

}